import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';

@Component({
	selector: 'merge-split-headings',
	templateUrl: './merge-split-headings.component.html',
	styleUrls: ['./merge-split-headings.component.scss']
})

export class MergeSplitHeadingsComponent implements OnInit, AfterViewInit, OnDestroy {

	userID = 0
	courseID = 0

	headingsAction = ''
	courseUnits: any[] = []
	selectedUnit = -1
	unitLessons: any[] = []
	selectedLesson = -1
	lessonHeadings: any[] = []
	selectedHeadings: any[] = []
	newHeadingName = ''
	splitChars = '@@@@@'
	selectedHeadingsText = ''
	showSelectAllButton = false

	mergeBtnDisabled = true
	mergeLoading = false
	mergeError = false
	mergeSuccess = false
	splitBtnDisabled = true
	splitLoading = false
	splitError = false
	splitSuccess = false

	showCourseSub = new Subscription
	mergeHeadingsSub = new Subscription
	splitHeadingsSub = new Subscription

	constructor(private dataService: ApiService, private route: ActivatedRoute) { }

	ngOnInit() {
		this.userID = this.dataService.getUserID()
		this.courseID = Number(this.route.snapshot.paramMap.get('id'))
	}

	ngAfterViewInit() {
		this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				console.log(course)
				this.courseUnits = course.units
			},
			error => {
				console.log(error)
			},
		);
	}

	ngOnDestroy() {
		this.showCourseSub?.unsubscribe()
		this.mergeHeadingsSub?.unsubscribe()
		this.splitHeadingsSub?.unsubscribe()
	}

	selectUnit(unitId: number) {
		this.selectedUnit = unitId;
		this.unitLessons = this.courseUnits.find((unit) => {
			return +unitId === +unit.id
		}).lessons

		this.selectedLesson = -1
		this.lessonHeadings = []
		this.selectedHeadings = []
		this.newHeadingName = ''
		this.selectedHeadingsText = ''

		this.mergeSuccess = false
		this.mergeLoading = false
		this.mergeError = false
		this.mergeBtnDisabled = true

		if (this.unitLessons.length === 1) {
			this.selectLesson(this.unitLessons[0].id)
		}
	}

	selectLesson(lessonId: number) {
		this.selectedLesson = +lessonId
		let lesson = this.unitLessons.find((lesson) => {
			return +lessonId === +lesson.id
		})
		console.log(this.selectedLesson)
		console.log(lesson.headings)
		// this.newHeadingName = lesson!.name.split(': ')[1]
		this.lessonHeadings = lesson.headings
		this.selectedHeadings = []
		this.newHeadingName = ''
		this.selectedHeadingsText = ''

		this.mergeSuccess = false
		this.mergeLoading = false
		this.mergeError = false
		this.mergeBtnDisabled = true

		if (this.headingsAction === 'split' && this.lessonHeadings.length === 1) {
			this.selectHeading(this.lessonHeadings[0].id, this.lessonHeadings[0].name);
		}
	}

	selectAllHeadings() {
		// console.log(this.selectedLesson);
		// console.log(this.lessonHeadings);
		// console.log(this.selectedHeadings);
		let newHeadingName = ''
		this.selectedHeadings = []
		this.selectedHeadings = this.lessonHeadings
		newHeadingName = this.selectedHeadings[this.selectedHeadings.length - 1].name
		// this.lessonHeadings.forEach((heading) => {
		// 	this.selectedHeadings.push(heading)
		// 	newHeadingName = heading.name
		// })
		// console.log(this.selectedHeadings)
		this.updateNewHeadingName(newHeadingName)
		this.updateSelectedHeadingsText()

		this.mergeBtnDisabled = false
	}

	selectHeading(headingId: number, headingName: string) {
		// console.log(headingId)
		let index = this.selectedHeadings.findIndex((result) => {
			return +headingId === +result.id
		})
		// console.log(index)

		if (index > -1) {
			this.selectedHeadings?.splice(index, 1)
		} else {
			let newHeading = this.lessonHeadings!.find((heading) => {
				// console.log(heading.id)
				// console.log(headingId)
				return +headingId === +heading.id
			});
			this.selectedHeadings.push(newHeading)
		}
		// console.log(this.selectedHeadings);
		this.selectedHeadings?.sort((a, b) => (a.position > b.position) ? 1 : -1)
		
		this.updateNewHeadingName(headingName)
		this.updateSelectedHeadingsText()

		this.mergeBtnDisabled = this.headingsAction != 'merge' && this.selectedHeadings.length === 0
		this.splitBtnDisabled = this.headingsAction != 'split' && this.selectedHeadings.length === 0
	}

	updateNewHeadingName(newHeadingName: string) {
		this.newHeadingName = newHeadingName.split(' (')[0]
	}

	updateSelectedHeadingsText() {
		this.selectedHeadingsText = ''
		this.selectedHeadings?.forEach((heading) => {
			this.selectedHeadingsText += heading.content
			// this.selectedHeadingsText += '<p>' + heading.content + '</p>'
		});
	}

	mergeHeadings() {
		console.log(this.selectedHeadings)
		console.log(this.newHeadingName)
		console.log(this.selectedHeadingsText)

		this.mergeLoading = true
		this.mergeError = false
		this.mergeSuccess = false
		
		this.mergeHeadingsSub = this.dataService.mergeHeadings(this.selectedLesson, this.selectedHeadings, this.newHeadingName, this.selectedHeadingsText)
		.subscribe(
			data => {
				console.log(data)
				this.mergeSuccess = true
				this.mergeLoading = false
				this.mergeError = false
				this.selectedUnit = -1
				this.selectedLesson = -1
				this.lessonHeadings = []
				this.selectedHeadings = []
				this.newHeadingName = ''
				this.selectedHeadingsText = ''
				this.mergeBtnDisabled = true

				this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
				.subscribe(
					course => {
						this.courseUnits = course.units
						this.unitLessons = this.courseUnits.find((unit) => {
							return this.selectedUnit === +unit.id
						}).lessons
					},
					error => {
						console.log(error)
					},
				);
			},
			error => {
				console.log(error)
				this.mergeError = true
				this.mergeLoading = false
				this.mergeSuccess = false
			},
		);
	}

	splitHeadings() {
		console.log(this.selectedHeadings)
		console.log(this.newHeadingName)
		console.log(this.selectedHeadingsText)

		this.splitLoading = true
		this.splitError = false
		this.splitSuccess = false

		this.splitHeadingsSub = this.dataService.splitHeadings(this.selectedLesson, this.selectedHeadings[0], this.selectedHeadingsText, this.splitChars)
		.subscribe(
			data => {
				console.log(data);
				this.splitSuccess = true
				this.splitLoading = false
				this.splitError = false
				this.selectedUnit = -1
				this.selectedLesson = -1
				this.lessonHeadings = []
				this.selectedHeadings = []
				this.selectedHeadingsText = ''
				this.splitBtnDisabled = true

				this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
				.subscribe(
					course => {
						this.courseUnits = course.units
						this.unitLessons = this.courseUnits.find((unit) => {
							return this.selectedUnit === +unit.id
						}).lessons
					},
					error => {
						console.log(error)
					},
				);
			},
			error => {
				console.log(error)
				this.splitError = true
				this.splitLoading = false
				this.splitSuccess = false
			},
		);
	}

}
